import React from "react";
import Form from "../../components/Form";

export default function CostCenter(){
  return <Form type={"costCenter"}/>;
}